import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { api } from './api';
import { labelForPath } from '../layout/nav';

/** كل كم ثانيةً تُبعث النبضة — أقلُّ من نافذة «متّصل الآن» في الخادم (١٥ث). */
const BEAT_EVERY_MS = 8000;

/**
 * نبضةُ نشاطٍ إلى الخادم: أين المستخدم الآن، وأنه ما زال متّصلًا.
 *
 * تعمل ما دام التطبيق مفتوحًا، بلا إذنٍ ولا مشاركة شاشة — فلوحة المراقبة
 * تعرف على أيّ شاشةٍ يعمل كلُّ موظفٍ لحظةً بلحظة، ومن انقطع. هذا هو «ماذا
 * يفعل على النظام» في أخفّ صوره؛ والصورة الحيّة طبقةٌ فوقه تحتاج مشاركة
 * الشاشة.
 *
 * وتتوقّف حين تختفي الصفحة (تبويبٌ في الخلفية): لا معنى لتسجيل «متّصل» لمن
 * غادر إلى تبويبٍ آخر، وهو ما يوفّر نبضاتٍ لا تصف عملًا.
 */
export function useActivityHeartbeat(enabled: boolean): void {
  const location = useLocation();
  const pathRef = useRef(location.pathname);
  pathRef.current = location.pathname;

  useEffect(() => {
    if (!enabled) return;

    const beat = () => {
      if (document.visibilityState !== 'visible') return;
      const path = pathRef.current;
      void api('/callcenter/monitor/heartbeat', {
        method: 'POST',
        body: { path, label: labelForPath(path) },
      }).catch(() => undefined);
    };

    beat();
    const timer = window.setInterval(beat, BEAT_EVERY_MS);
    /* نبضةٌ فور العودة إلى التبويب، فلا ينتظر المدير دورةً كاملة ليراه عاد. */
    const onVis = () => beat();
    document.addEventListener('visibilitychange', onVis);

    return () => {
      window.clearInterval(timer);
      document.removeEventListener('visibilitychange', onVis);
    };
  }, [enabled]);
}
